var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"header"},[_c('patientHeader')],1),_c('div',{staticClass:"inside-container"},[_c('div',[_c('leftMenu')],1),_c('div',[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }